var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('img',{staticClass:"error-img",attrs:{"src":require("@/assets/img/error-image.png"),"alt":"错误"}}),_c('h2',[_vm._v("页面参数错误，请联系管理员")]),_c('van-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.replace('/')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }